module.exports = __webpack_public_path__ + "static/media/tipologia1.bf2ccc8d.png";